import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvestmentFinancialListComponent } from './investment-financial-list.component';
import { InvestmentFinancialService } from './investment-financial.service';

@Component({
    selector: 'convfact-investmentfinancialdelete',
    templateUrl: './investment-financial-dialog-delete.component.html',
    styleUrls: ['./investment-financial.component.css'],
    standalone: false
})
export class InvestmentFinancialDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<InvestmentFinancialListComponent>,
    public investmentFinancialService: InvestmentFinancialService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.investmentFinancialService.delete(this.uid)
      .then(res => {
        this.response_message = "Se ha eliminado correctamente la inversión";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar la inversión";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
